import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ZavrseneEdukacijeService } from './zavrseneedukacije.service';
import { UcionicaService } from '../ucionica-popis/ucionica-popis.service'
import { ZavrsenaEdukacija } from './zavrsenaedukacija';
import { Subject } from 'rxjs';
declare var moment: any;
import * as toastr from 'toastr';
import * as alertify from 'alertify.js';
import { AppConfig } from '../../../config';

@Component({
  selector: 'app-zavrseneedukacije',
  templateUrl: './zavrseneedukacije.component.html',
  styleUrls: ['./zavrseneedukacije.component.css'],
  providers: [ZavrseneEdukacijeService, UcionicaService]
})

export class ZavrseneEdukacijeComponent implements OnInit {

  URL: any = AppConfig.IPfile;
  accessToken: any = localStorage.getItem('tokenSql');

  myDatePickerOptions = {
		todayBtnTxt: 'Danas',
		dateFormat: 'dd.mm.yyyy',
		firstDayOfWeek: 'mo',
		sunHighlight: true,
		height: '34px',
		width: '100%',
		inline: false,
		selectionTxtFontSize: '16px',
		dayLabels: {su: 'Ned', mo: 'Pon', tu: 'Uto', we: 'Sri', th: 'Čet', fr: 'Pet', sa: 'Sub'},
		monthLabels: { 1: 'Sij', 2: 'Velj', 3: 'Ožu', 4: 'Tra', 5: 'Svi', 6: 'Lip', 7: 'Srp', 8: 'Kol', 9: 'Ruj', 10: 'Lis', 11: 'Stu', 12: 'Pro' }
	};

  sveZavrseneedukacije: ZavrsenaEdukacija[] = [];
  zavrseneedukacijeOptions: DataTables.Settings = {};
  zavrseneedukacijeTrigger: Subject<ZavrsenaEdukacija> = new Subject();

  datumOd: any;
  datumDo: any;
  datumraneprijave: any;
  datumkasneprijave: any;

  ucionicaEditForma: FormGroup;

  vrstaEdukacije: any = 'all';

  disabledIndividualno: boolean = false;

  silabusSpreman: boolean = false;
  cjelovitiSilabus: string;
  idUcionica: any;
  cekamSilabus: boolean = false;

  constructor(
    private _fb: FormBuilder,
    private _ucionicaService: UcionicaService,
    private _zavrseneEdukacijeService: ZavrseneEdukacijeService
  ) { }

  ngOnInit() {
    this.dohvati();
    //Tablica početak
    this.zavrseneedukacijeOptions = {
      pagingType: 'full_numbers',
      pageLength: 50,
      responsive: true,
      columnDefs: [{
        targets: 'no-sort',
        orderable: false
      }],
      retrieve: true
    };
    //Tablica kraj
    this.ucionicaEditForma = this._fb.group({
      iducionica: [''],
      naziv: [''],
      vrstaEdukacije: [''],
      trajanjeEdukacije: [''],
      grad: [''],
      datumOd: [''],
      datumDo: [''],
      cijena: [''],
      popustranaprijava: [''],
      popustdvapolaznika: [''],
      popusttripolaznika: [''],
      datumraneprijave: [''],
      datumkasneprijave: [''],
      prikazivise: [''],
      cjelovitisilabus: [''],
      osnovneikomercijalneinformacije: [''],
      infovideo: [''],
      promovideo: [''],
      prikazweb: [''],
      otkaziedukaciju: [''],
      individualno: ['']
    });
  }

  dohvati(){
    this.sveZavrseneedukacije = [];
    this._zavrseneEdukacijeService.dohvatiZavrseneEdukacije({'idkorisnik': localStorage.getItem('userId'), 'vrstaedukacije': this.vrstaEdukacije}).subscribe(res => {
      //console.log(res);
      if(res.success == true){
        for(let i = 0; i < res.data.length; i++){
          if(res.data[i]['uc_datumod'] && res.data[i]['uc_datumdo']){
            this.sveZavrseneedukacije.push({
              'id': res.data[i]['iducionica'],
              'wp_id': res.data[i]['uc_wpiducionica'],
              'naziv': res.data[i]['uc_naziv'],
              'vrstaEdukacije': res.data[i]['uc_vrstaEdukacije'],
              'trajanjeEdukacije': res.data[i]['uc_trajanjeEdukacije'],
              'grad': res.data[i]['uc_grad'],
              'datumOd': moment(res.data[i]['uc_datumod']).format('DD.MM.YYYY.'),
              'datumDo': moment(res.data[i]['uc_datumdo']).format('DD.MM.YYYY.'),
              'cijena': res.data[i]['uc_cijena'],
              'popustranaprijava': res.data[i]['uc_popustranaprijava'],
              'popustdvapolaznika': res.data[i]['uc_popustdvapolaznika'],
              'popusttripolaznika': res.data[i]['uc_popusttripolaznika'],
              'datumraneprijave': res.data[i]['datumraneprijaveprikaz'],
              'datumkasneprijave': res.data[i]['datumkasneprijaveprikaz'],
              'prikazivise': res.data[i]['uc_prikazivise'],
              'cjelovitisilabus': res.data[i]['uc_preuzimanjecjelovitogsilabusa'],
              'osnovneikomercijalneinformacije': res.data[i]['uc_osnovneikomercijalneinformacije'],
              'infovideo': res.data[i]['uc_infovideo'],
              'promovideo': res.data[i]['uc_promovideo'],
              'brojpolaznika': res.data[i]['brojpolaznika'],
              'statusucionice': res.data[i]['uc_status'],
              'prikazweb': res.data[i]['uc_prikazweb']
            });
          } else {
            this.sveZavrseneedukacije.push({
              'id': res.data[i]['iducionica'],
              'wp_id': res.data[i]['uc_wpiducionica'],
              'naziv': res.data[i]['uc_naziv'],
              'vrstaEdukacije': res.data[i]['uc_vrstaEdukacije'],
              'trajanjeEdukacije': res.data[i]['uc_trajanjeEdukacije'],
              'grad': res.data[i]['uc_grad'],
              'datumOd': null,
              'datumDo': null,
              'cijena': res.data[i]['uc_cijena'],
              'popustranaprijava': res.data[i]['uc_popustranaprijava'],
              'popustdvapolaznika': res.data[i]['uc_popustdvapolaznika'],
              'popusttripolaznika': res.data[i]['uc_popusttripolaznika'],
              'datumraneprijave': res.data[i]['datumraneprijaveprikaz'],
              'datumkasneprijave': res.data[i]['datumkasneprijaveprikaz'],
              'prikazivise': res.data[i]['uc_prikazivise'],
              'cjelovitisilabus': res.data[i]['uc_preuzimanjecjelovitogsilabusa'],
              'osnovneikomercijalneinformacije': res.data[i]['uc_osnovneikomercijalneinformacije'],
              'infovideo': res.data[i]['uc_infovideo'],
              'promovideo': res.data[i]['uc_promovideo'],
              'brojpolaznika': res.data[i]['brojpolaznika'],
              'statusucionice': res.data[i]['uc_status'],
              'prikazweb': res.data[i]['uc_prikazweb']
            });
          }
        }
        this.zavrseneedukacijeTrigger.next();
      } else {
        toastr.error("Neuspješno dohvaćanje!");
      }
    })
  }

  pripremiPodatke(ucionica){
    // console.log(ucionica);
    this.ucionicaEditForma = this._fb.group({
      iducionica: ucionica['id'],
      naziv: ucionica['naziv'],
      vrstaEdukacije: ucionica['vrstaEdukacije'],
      trajanjeEdukacije: ucionica['trajanjeEdukacije'],
      grad: ucionica['grad'],
      datumOd: ucionica['datumOd'],
      datumDo: ucionica['datumDo'],
      cijena: ucionica['cijena'],
      popustranaprijava: ucionica['popustranaprijava'],
      popustdvapolaznika: ucionica['popustdvapolaznika'],
      popusttripolaznika: ucionica['popusttripolaznika'],
      datumraneprijave: ucionica['datumraneprijave'],
      datumkasneprijave: ucionica['datumkasneprijave'],
      prikazivise: ucionica['prikazivise'],
      cjelovitisilabus: ucionica['cjelovitisilabus'],
      osnovneikomercijalneinformacije: ucionica['osnovneikomercijalneinformacije'],
      infovideo: ucionica['infovideo'],
      promovideo: ucionica['promovideo'],
      prikazweb: ucionica['prikazweb'],
      otkaziedukaciju: ucionica['statusucionice']
    });
    this.idUcionica = this.ucionicaEditForma.value.iducionica;
    this.datumOd = ucionica['datumOd'];
    this.datumDo = ucionica['datumDo'];
    this.datumraneprijave = ucionica['datumraneprijave'];
    this.datumkasneprijave = ucionica['datumkasneprijave'];

    if(this.ucionicaEditForma.value.grad == 'Individualno'){
      this.disabledIndividualno = true;
    }else{
      this.disabledIndividualno = false;
    }

    this.silabusSpreman = false;
    this.cekamSilabus = false;

  }

  pripremaZaKreiranjeSilabusa(){
    this.silabusSpreman = false;
    this._ucionicaService.dohvati_idmodule_za_ucionicu({'iducionica': this.idUcionica}).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        if(res.data.length == 0){
          toastr.error("Ne može se kreirati PDF! Ne postoje ID moduli!");
        } else {
          let tmpArray = [];
          res.data.forEach(element => {
            // console.log(element.idmodul);
            tmpArray.push(element.idmodul);
            if(res.data.length == tmpArray.length){
              this.kreirajSilabus(tmpArray);
            }
          });
        }
      } else {
        toastr.error(res.message);
      }
    });
  }

  kreirajSilabus(idmoduli){
    let objektZaKreiranjeSilabusa = {
      'iducionica': this.idUcionica,
      'nazivtablice': 'syllabus',
      'idmoduli': idmoduli
    };
    // console.log(objektZaKreiranjeSilabusa);
    this.cekamSilabus = true;
    this._ucionicaService.kreiranje_syllabusa(objektZaKreiranjeSilabusa).subscribe(res => {
      // console.log(res);
      if(res.success == true){
        this.cjelovitiSilabus = res.data;
        this.silabusSpreman = true;
        this.cekamSilabus = false;
      } else {
        toastr.error(res.message);
      }
    },
    err => {
      toastr.error("Greška! PDF silabus se nije kreirao!");
      this.cekamSilabus = false;
      }
    );
  }

  urediUcionicu(ucionica){
    //console.log(ucionica);
    let datum1; 
    let datum2;
    if(ucionica.value.datumOd){
      if(ucionica.value.datumOd.jsdate){
        datum1 = moment(ucionica.value.datumOd.jsdate).format('YYYY-MM-DD');
      } else {
        datum1 = moment(ucionica.value.datumOd,'DD.MM.YYYY.').format('YYYY-MM-DD');
      }
    }
    if(ucionica.value.datumDo){
      if(ucionica.value.datumDo.jsdate){
        datum2 = moment(ucionica.value.datumDo.jsdate).format('YYYY-MM-DD');
      } else {
        datum2 = moment(ucionica.value.datumDo,'DD.MM.YYYY.').format('YYYY-MM-DD');
      }
    }

    if(ucionica.value.vrstaEdukacije == 2){
      ucionica.value.trajanjeEdukacije = '';
    }

    let datum_rane_prijave;
    let datum_kasne_prijave;
    if(ucionica.value.datumraneprijave){
      if(ucionica.value.datumraneprijave.jsdate){
        datum_rane_prijave = moment(ucionica.value.datumraneprijave.jsdate).format('YYYY-MM-DD');
      }else{
        datum_rane_prijave = moment(ucionica.value.datumraneprijave,'DD.MM.YYYY.').format('YYYY-MM-DD');
      }
    }
    if(ucionica.value.datumkasneprijave){
      if(ucionica.value.datumkasneprijave.jsdate){
        datum_kasne_prijave = moment(ucionica.value.datumkasneprijave.jsdate).format('YYYY-MM-DD');
      }else{
        datum_kasne_prijave = moment(ucionica.value.datumkasneprijave,'DD.MM.YYYY.').format('YYYY-MM-DD');
      }
    }

    let prikazwebzaslanje;
    if(ucionica.value.prikazweb == true){
      prikazwebzaslanje = 1;
    } else {
      prikazwebzaslanje = 0;
    }

    let otkaziedukacijuzaslanje;
    if(ucionica.value.otkaziedukaciju == true){
      otkaziedukacijuzaslanje = 1;
    } else {
      otkaziedukacijuzaslanje = 0;
    }

    let objektZaSlanje = {
      iducionica: ucionica.value.iducionica,
      naziv: ucionica.value.naziv,
      vrstaEdukacije: ucionica.value.vrstaEdukacije,
      trajanjeEdukacije: ucionica.value.trajanjeEdukacije,
      grad: ucionica.value.grad,
      datumOd: datum1,
      datumDo: datum2,
      cijena: ucionica.value.cijena,
      popustranaprijava: ucionica.value.popustranaprijava,
      popustdvapolaznika: ucionica.value.popustdvapolaznika,
      popusttripolaznika: ucionica.value.popusttripolaznika,
      datumraneprijave: datum_rane_prijave,
      datumkasneprijave: datum_kasne_prijave,
      prikazivise: ucionica.value.prikazivise,
      preuzimanjecjelovitogsilabusa: ucionica.value.cjelovitisilabus,
      osnovneikomercijalneinformacije: ucionica.value.osnovneikomercijalneinformacije,
      infovideo: ucionica.value.infovideo,
      promovideo: ucionica.value.promovideo,
      prikazweb: prikazwebzaslanje,
      otkaziedukaciju: otkaziedukacijuzaslanje
    }
    //console.log(objektZaSlanje);

    this._ucionicaService.urediUcionicu(objektZaSlanje).subscribe(res => {
      if(res.success == true){
        toastr.success("Uspješno uređivanje!");
        $('#ucionicaTablica').DataTable().destroy();
        this.dohvati();
      } else {
        toastr.error(res.message);
      }
    });

  }

  kopirajUcionicu(ucionica){
    let ovo = this;
    alertify
    .okBtn("Umnoži")
    .cancelBtn("Odustani")
    .confirm("Jeste li sigurni da želite umnožiti učionicu?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._ucionicaService.kopiraj({idkorisnik: localStorage.getItem('userId'), 'iducionica': ucionica.id}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Učionica uspješno kopirana...");
            ovo.dohvati();
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste umnožavanja učionice.');
    });
  }

  obrisiUcionicuAlert(ucionica){
    let ovo = this;
    alertify
    .okBtn("Da")
    .cancelBtn("Ne")
    .confirm("Jeste li sigurni da želite obrisati učionicu?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo.obrisiUcionicu(ucionica);
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja učionice.');
    });
  }

  obrisiUcionicu(ucionica){
    let ovo = this;
    alertify
    .okBtn("Obriši")
    .cancelBtn("Odustani")
    .confirm("Obriši učionicu?", function (ev) {
      ev.preventDefault();
      if (alertify.success){
        ovo._ucionicaService.brisanjeUcionice({'iducionica': ucionica.id}).subscribe(res => {
          //console.log(res);
          if(res.success == true){
            toastr.success("Uspješno obrisana učionica!");
            ovo.dohvati();
          } else {
            toastr.error(res.message);
          }
        })
      }
    }, function(ev) {
      ev.preventDefault();
      toastr.info('Odustali ste od brisanja učionice.');
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/zavrseneedukacije/zavrseneedukacije.component.ts